<script setup lang="ts">
import { computed, inject } from 'vue';
import type { MainMenuContext, MainMenuItemProps } from './MainMenu.types';

const props = withDefaults(defineProps<MainMenuItemProps>(), {
  itemUrl: null,
  hasChildren: false,
  isExpandable: true,
  displayMode: 'auto',
});

const mainMenu = inject<MainMenuContext>('mainMenu');

const isHovered = computed(() => {
  return mainMenu?.selectedKey?.value === props.itemKey;
});

const handleMouseEnter = () => {
  if (!props.isExpandable) {
    return;
  }
  if (mainMenu) {
    mainMenu.toggle(props.itemKey);
  }
};

const handleClick = (event: MouseEvent) => {
  if (!props.isExpandable) {
    return;
  }
  if (mainMenu?.selectedKey?.value === props.itemKey && props.itemUrl) {
    event.preventDefault();
    window.location.href = props.itemUrl;
  } else if (mainMenu) {
    mainMenu.toggle(props.itemKey);
  }
};

defineExpose({
  handleMouseEnter,
  handleClick,
  isHovered,
});
</script>

<template>
  <div
    class="main-menu__head-item"
    :class="{ 'main-menu__item--hover': isHovered }"
    @mouseenter="handleMouseEnter"
  >
    <slot />
  </div>
</template>

<style lang="scss"></style>
